<template slot="content">
  <dialog-v2
    :show="show"
    title="Crear plantilla"
    :disable-save-btn="disableBtn"
    @close="$emit('close')"
    @save="save">
    <template slot="content">
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex md6>
            <v-text-field
              v-model="form.name"
              v-validate="'required'"
              data-vv-name="name"
              data-vv-as="nombre"
              data-vv-scope="campaing-template"
              :error-messages="errors.collect('name')"
              label="Nombre"
              color="black">
            </v-text-field>
          </v-flex>
          <v-flex md6>
            <v-text-field
              v-model="form.template_code"
              v-validate="'required'"
              data-vv-name="template_code"
              data-vv-as="codigo de plantilla"
              data-vv-scope="campaing-template"
              :error-messages="errors.collect('template_code')"
              label="Codigo de plantilla"
              color="black">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md12>
            <v-menu offset-y class="w-100" max-height="250px">
              <v-text-field
                v-model="form.category"
                @input="findCategory"
                slot="activator"
                label="Categoria"
                item-text="category"
                item-value="category"
                v-validate="'required'"
                data-vv-name="category"
                data-vv-as="categoria"
               data-vv-scope="campaing-template"
                :error-messages="errors.collect('category')"
                color="black">
              </v-text-field>
              <v-list v-if="categoriesSaved.length > 0">
                <v-list-tile v-for="item in categoriesSaved" :key="item.key" @click="form.category = item.category">
                  <v-list-tile-title>{{ item.category }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
              <v-list v-else>
                <v-list-tile>
                  <v-list-tile-title class="grey--text">No se encontraron registros</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-container>
    </template>
  </dialog-v2>
</template>

<script>
import DialogV2 from '@/components/global/DialogV2';

export default {
  inject: ['$validator'],
  components: {
    DialogV2,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    categoriesSaved: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      form: {
        name: '',
        category: '',
        template_code: '',
      },
    };
  },
  computed: {
    disableBtn() {
      return this.errors.any();
    },
  },
  methods: {
    findCategory() {
      // TO DO
    },
    save() {
      this.$validator.validateAll('campaing-template').then((validation) => {
        if (validation) {
          this.axios.post('templates', {
            ...this.form,
          }).then(() => {
            this.$emit('saved');
            this.$emit('close');
          });
        }
      });
    },
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.errors.clear();
      },
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/templateV2/CreateTemplateDialog.vue